import React from 'react'
import { I18n } from '@front/volcanion'

import FormatUtils from '@front/squirtle/utils/format'
import { TextCell } from '@abra/elements/table/cells/basics/'
import { TableCell } from '@mui/material'

import { DriverLink, OrderLink } from '@abra/elements'

const Row = ({ row }) => {
  const { data, transport, vehicle } = row
  const createdAt = FormatUtils.formatDateBackToFront(row?.createdAt, 'DD/MM/YYYY HH:mm')
  const plaque =
    data?.vehicle?.info?.plaque || transport?.vehicle?.info?.plaque || vehicle?.info?.plaque
  const license_number =
    data?.parent_license?.license_number || transport?.license?.license_number || vehicle?.parent_license?.license_number
  const license_client_id =
    data?.license?.license_client_id || transport?.license?.license_client_id || vehicle?.parent_license?.license_client_id

  return <>
    <TableCell size={'small'}><TextCell value={createdAt} /></TableCell>
    <TableCell size={'small'}><TextCell value={I18n.t(`event.${row?.name}`)} /></TableCell>
    <TableCell size={'small'}>
      {!!row?.order
        ? <OrderLink record_id={row?.order} />
        : '-'
      }
    </TableCell>
    <TableCell size={'small'}>
      {!!row?.driver?.user_id
        ? <DriverLink record_id={row?.driver?.user_id} />
        : '-'
      }
    </TableCell>
    <TableCell size={'small'}><TextCell value={plaque} /></TableCell>
    <TableCell size={'small'}><TextCell value={license_number} /></TableCell>
    <TableCell size={'small'}><TextCell value={license_client_id} /></TableCell>
  </>
}

export default React.memo(Row)
